import {NgModule} from "@angular/core";
import {BrowserModule} from "@angular/platform-browser";
import {AutoLinkToLabelDirective} from "./auto-link-to-label.directive";

@NgModule({
  imports: [BrowserModule],
  declarations: [AutoLinkToLabelDirective],
  exports: [AutoLinkToLabelDirective],
})
export class FormHelpersModule {

}
